import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { AccountMarketplace, OrganizationAmazonUserAccess } from "@front/m19-api-client";
import { AccountMarketplaceService } from "@front/m19-services";
import { IButtonDirective, IIconComponent, MODAL_DATA, ModalRef, ToasterService } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { SpinnerComponent } from "@front/m19-ui";
import { take } from "rxjs/operators";

@Component({
  templateUrl: "./renew-amazon-access-modal.component.html",
  imports: [TranslocoDirective, IButtonDirective, SpinnerComponent, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenewAmazonAccessModalComponent {
  private accountMarketplaceService = inject(AccountMarketplaceService);
  private toasterService = inject(ToasterService);

  modalData = inject(MODAL_DATA) as RenewAmazonAccessModalData;
  modalRef = inject(ModalRef);

  loading = signal(false);

  renew(): void {
    this.loading.set(true);
    this.accountMarketplaceService
      .addAmazonUser(this.modalData.organizationId, this.modalData.accountMarketplace)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.loading.set(false);
          this.toasterService.success("Access successfully renewed", "Login with Amazon");
          this.modalRef.close();
        },
        error: (errorMessage) => {
          this.loading.set(false);
          this.toasterService.error(errorMessage, "Login with Amazon error");
        },
      });
  }

  close() {
    this.modalRef.close();
  }
}

export interface RenewAmazonAccessModalData {
  amazonUserAccess: OrganizationAmazonUserAccess[];
  organizationId: number;
  accountMarketplace: AccountMarketplace;
  canRenewAccess: boolean;
}
